<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div class="full-height">
      <el-form :model="form" ref="form" label-position="top" :rules="rules">
        <el-row>
          <el-col :lg="12" :sm="12">
            <el-form-item label="持久化开关" prop="ispersistent" required>
              <el-switch
                v-model="form.ispersistent"
                active-text="关闭"
                inactive-text="开启">
              </el-switch>
            </el-form-item>
          </el-col>
          <el-col :lg="12" :sm="12">
            <el-form-item label="处理线程数" prop="spNum" required>
              <el-input-number v-model="form.spNum" disabled></el-input-number>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :lg="12" :sm="12">
            <el-form-item label="持久化记录保留时长(天)" prop="pmsgkeepdays" required>
              <el-input-number v-model="form.pmsgkeepdays" :min="1"></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :lg="12" :sm="12">
            <el-form-item label="持久化备份保留时长(天)" prop="pmsgbackdays" required>
              <el-input-number v-model="form.pmsgbackdays" :min="1"></el-input-number>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
            <el-form-item label="文件持久化默认根路径" prop="backupbasepath" required>
              <el-input v-model="form.backupbasepath" />
            </el-form-item>
          <el-form-item label="持久化备份默认根路径" prop="backupfilepath" required>
            <el-input v-model="form.backupfilepath" />
          </el-form-item>
        </el-row>
      </el-form>
  </div>
</template>

<script>
import EasyConfigApi from "@/api/basics/EasyConfigApi";
import CommonValidate from "@/libs/Validate";

export default {
  name: "paraconfig",
  components: { },
  computed: {},
  data() {
    return {
      form: {
        ispersistent:"",
        pmsgkeepdays:"7",
        pmsgbackdays:"30",
        backupbasepath:"./EtongMessageData/",
        backupfilepath:"./EtongBackupData/",
        spnum:"10",
      },
      rules: {
        pmsgkeepdays: [{ required: true, message: "这是必填字段" },
          {validator: CommonValidate.checkNumber, trigger: ["blur", "change"]},],
        backupbasepath: [{ required: true, message: "这是必填字段" },
          {validator: CommonValidate.checkSpecificKey, trigger: ["blur", "change"]},],
        pmsgbackdays: [{ required: true, message: "这是必填字段" },
          {validator: CommonValidate.checkSpecificKey, trigger: ["blur", "change"]},],
        backupfilepath: [{ required: true, message: "这是必填字段" },
          {validator: CommonValidate.checkSpecificKey, trigger: ["blur", "change"]},],
      },
    };
  },
  async mounted() {
    this.query();
  },
  methods: {
    query(){
      EasyConfigApi.queryPara().then(resp=>{
        this.form = resp.datas;
      });
    },
    async save(){
      await this.$refs.form.validate();
      EasyConfigApi.doSubmitPara(this.form).then(()=>this.query());
    }
  },
};
</script>
